import React from 'react'
import { Link } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const FeaturedPost = ({ featuredInfo }) => {
  const featuredPost = featuredInfo.edges[0].node
  const image = getImage(featuredPost.featuredImage.node.localFile)
  return (
    <div className='flex flex-col lg:flex-row container px-0 bg-white'>
      <div
        className='lg:basis-1/2 flex bg-white lg:max-h-full md:max-h-[415px] w-full max-h-[330px]'
        data-aos='fade-up'
        data-aos-duration='500'
        data-aos-easing='ease-in-out'
      >
        <GatsbyImage
          image={image}
          alt={featuredPost.title}
          className='w-full object-cover'
        />
      </div>
      <div className='bg-black-100 container text-white flex flex-col items-start pt-[35px] pb-[80px] md:pb-[60px] border-t-white md:border-none lg:pt-[65px] lg:pb-[75px] lg:pl-[55px] lg:w-[50%] lg:mr-[80px]'>
        <p className='text-lg text-gray-300 pb-[20px]'>{featuredPost.date}</p>
        <h2
          className='text-head xl:max-w-[550px] pb-[20px] md:text-4xl md:max-w-[400px] md:pb-[10px]'
          data-aos='fade-up'
          data-aos-duration='500'
          data-aos-easing='ease-in-out'
        >
          {featuredPost.title}
        </h2>
        <p
          className='text-lg pb-[30px] md:pb-[35px]'
          dangerouslySetInnerHTML={{ __html: featuredPost.excerpt }}
          data-aos='fade-up'
          data-aos-duration='500'
          data-aos-easing='ease-in-out'
        ></p>
        <Link
          to={`/blog/${featuredPost.slug}`}
          className='primary-button text-black-100  inline-block font-medium px-[65px] py-[25px] whitespace-nowrap'
          data-aos='fade-up'
          data-aos-duration='500'
          data-aos-easing='ease-in-out'
        >
          Read more
        </Link>
      </div>
    </div>
  )
}

export default FeaturedPost
